export default {
      id: "oc-res-ai-routing-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-ai-routing",
      toString: function () {
        return this.url;
      }
    }